import React from "react";

export default function CustomerLogout() {
  const handleLogout = () => {
    // ✅ Local storage se data hatao
    localStorage.removeItem("userPhone");

    // ✅ Redirect login page ya home pe
    window.location.href = "/customer-login"; // apne route ke hisaab se badal le
  };

  return (
    <div style={{ padding: 30, textAlign: "center" }}>
      <h2>👋 You are logged in</h2>
      <button
        onClick={handleLogout}
        style={{
          padding: "10px 20px",
          backgroundColor: "#dc3545",
          color: "white",
          border: "none",
          borderRadius: "5px",
          fontSize: "16px",
          cursor: "pointer",
          marginTop: "20px",
        }}
      >
        Logout
      </button>
    </div>
  );
}
